import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    anticiGubun: "",
    acnoInfo: {},
    RBF0407B40: {
      pre1: {
        request: {},
        response: {},
      },
      pre2: {
        request: {},
        response: {},
      },
    },
    RBF0407F40: {
      pre1: {
        request: {},
        response: {},
      },
      pre2: {
        request: {},
        response: {},
      },
    },
    RBF0107A10: {
      request: {},
      response: {},
    },
    RBF0107E10: {
      request: {},
      response: {},
    },
  };
};

const lnamtRpayAnticiInq = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getAnticiGubun: state => {
      return state.anticiGubun;
    },
    getAcnoInfo: state => {
      return state.acnoInfo;
    },
    getRBF0407B40: state => {
      return state.RBF0407B40;
    },
    getRBF0407F40: state => {
      return state.RBF0407F40;
    },
    getRBF0107A10: state => {
      return state.RBF0107A10;
    },
    getRBF0107E10: state => {
      return state.RBF0107E10;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    setAnticiGubun: (state, obj) => {
      state.anticiGubun = obj;
    },
    setAcnoInfo: (state, obj) => {
      state.acnoInfo = obj;
    },
    setRBF0407B40: (state, obj) => {
      state.RBF0407B40 = obj;
    },
    setRBF0407F40: (state, obj) => {
      state.RBF0407F40 = obj;
    },
    setRBF0107A10: (state, obj) => {
      state.RBF0107A10 = obj;
    },
    setRBF0107E10: (state, obj) => {
      state.RBF0107E10 = obj;
    },
  },
  actions: {
    actSetAnticiGubun: (context, payload) => {
      context.commit("setAnticiGubun", payload);
    },
    actSetAcnoInfo: (context, payload) => {
      context.commit("setAcnoInfo", payload);
    },
    actSetRBF0407B40: (context, payload) => {
      context.commit("setRBF0407B40", payload);
    },
    actSetRBF0407F40: (context, payload) => {
      context.commit("setRBF0407F40", payload);
    },
    actSetRBF0107A10: (context, payload) => {
      context.commit("setRBF0107A10", payload);
    },
    actSetRBF0107E10: (context, payload) => {
      context.commit("setRBF0107E10", payload);
    },
  },
};

export default lnamtRpayAnticiInq;
